import { createApi } from '@reduxjs/toolkit/query/react';
import { customFetchBase } from './helpers/customFetchBase.js';
import { type Comment } from '@soulhx/fs-common';

export const commsApi = createApi({
  reducerPath: 'comms',
  baseQuery: customFetchBase,
  tagTypes: ['comments'],
  endpoints: (builder) => ({
    markCommentReadForAdmin: builder.mutation<Comment, Comment>({
      query: (item) => ({
        url: `/comms/comment/markRead/${item.id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['comments'],
    }),
    getUnreadCommentsForAdmin: builder.query<Comment[], void>({
      query: () => '/comms/comment/adminUnread',
      providesTags: ['comments'],
    }),
  }),
});

export const { useMarkCommentReadForAdminMutation, useGetUnreadCommentsForAdminQuery } = commsApi;
